
import Component from '../../../assets/scripts/modules/component'
import cookiesSimple from '../../../vendor/scripts/fabrique/modules/cookies-simple'
import fireCustomEvent from '../../../vendor/scripts/fabrique/modules/fire-custom-event'

class MenuBarComponent extends Component {
  init () {
    this.button = this.element.querySelector('.button--menu')
    this.region = this.element.querySelector('#menu-items')
    this.firstLink = this.element.querySelector('.menu-bar__link')

    this.minimizedToggle = this.element.querySelector('input[name="enable-minimized-homepage"]')

    if (this.minimizedToggle) {
      this.initMinimizedToggle()
    }

    if (this.button && this.region) {
      this.button.addEventListener('click', event => this.buttonHandler(event))
    }
  }

  initMinimizedToggle () {
    const enabled = cookiesSimple.get('enable-minimized-homepage') === 'true'

    document.documentElement.classList.toggle('enable-minimized-homepage', enabled)
    this.minimizedToggle.checked = enabled

    this.minimizedToggle.addEventListener('change', () => {
      cookiesSimple.set('enable-minimized-homepage', this.minimizedToggle.checked)
      document.documentElement.classList.toggle('enable-minimized-homepage', this.minimizedToggle.checked)
    })
  }

  buttonHandler (event) {
    if (this.button.getAttribute('aria-expanded') === 'true') {
      this.toggleRegion(true)
      this.button.focus()
    } else {
      this.toggleRegion(false)

      if (this.firstLink) {
        this.firstLink.focus()
      }
    }

    window.scroll({ top: 0, left: 0, behavior: 'smooth' })
  }

  toggleRegion (forceClose = false) {
    const focusableElements = [...this.region.querySelectorAll('a, button, input, select, textarea')]

    if (forceClose || this.button.getAttribute('aria-expanded') === 'true') {
      this.region.setAttribute('aria-hidden', true)
      this.button.setAttribute('aria-expanded', false)

      focusableElements.forEach(element => this.deactivateFocusableElement(element))
    } else {
      this.region.setAttribute('aria-hidden', false)
      this.button.setAttribute('aria-expanded', true)

      focusableElements.forEach(element => this.activateFocusableElement(element))
    }
  }

  deactivateFocusableElement (element) {
    const tabindex = element.getAttribute('tabindex')

    if (tabindex !== null) {
      element.setAttribute('data-tabindex', tabindex)
    }

    element.setAttribute('tabindex', -1)
  }

  activateFocusableElement (element) {
    const tabindex = element.getAttribute('data-tabindex')

    if (tabindex !== null) {
      element.setAttribute('tabindex', tabindex)
    } else {
      element.removeAttribute('tabindex')
    }

    element.removeAttribute('data-tabindex')
  }
}

window.addEventListener('init-load', () => {
  for (const element of document.querySelectorAll('.menu-bar')) {
    element.instance = element.instance || new MenuBarComponent(element)
  }
})
